import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.25rem 0;
`;

export const ListWeekContainer = styled.div``;

interface TodayPropsType {
  $isToday: boolean;
  $isPast: boolean;
}

export const WeekDay = styled.div<TodayPropsType>`
  color: ${(props) =>
    props.$isToday
      ? 'var(--primary-button-background-color)'
      : props.$isPast
      ? 'var(--app-secondary-text-color)'
      : 'var(--app-primary-text-color)'};
  font-size: 12px;
  font-weight: 500;
  @media screen and (max-width: 700px) {
    font-size: 10px;
  }
`;

export const MonthDayWrapper = styled.div<TodayPropsType>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: ${(props) =>
    props.$isToday ? 'white' : props.$isPast ? 'var(--app-secondary-text-color)' : 'var(--app-primary-text-color)'};
  background-color: ${(props) =>
    props.$isToday ? 'var(--primary-button-background-color)' : 'var(--app-primary-background-color)'};
  &:hover {
    cursor: pointer;
    background-color: ${(props) =>
      props.$isToday ? 'var(--primary-button-background-color)' : 'var(--secondary-button-hover-background-color)'};
  }
  @media screen and (max-width: 700px) {
    width: 30px;
    height: 30px;
  }
`;

export const MonthDay = styled.div`
  font-size: 22px;
  font-weight: 500;
  @media screen and (max-width: 700px) {
    font-size: 18px;
  }
`;
